var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmojiSadSmile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 28,
    viewBox: "0 0 30 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5259 27.9999C7.53843 27.9999 0 23.6171 0 13.9999C0 4.38281 7.53843 0 14.5259 0C18.4078 0 21.9892 1.27728 24.6439 3.60643C27.524 6.16098 29.0518 9.76741 29.0518 13.9999C29.0518 18.2325 27.524 21.8139 24.6439 24.3684C21.9892 26.6976 18.3828 27.9999 14.5259 27.9999Z",
    fill: "url(#paint0_radial_3056_1127)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.61685 8.5C8.56748 8.5 7.61328 9.38658 7.61328 10.8592C7.61328 12.3318 8.56748 13.2159 9.61685 13.2159C10.6687 13.2159 11.6204 12.3293 11.6204 10.8592C11.6204 9.38908 10.6787 8.5 9.61685 8.5Z",
    fill: "#422B0D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.52943 9.48474C9.1738 9.31443 8.74554 9.4647 8.57273 9.82033C8.43999 10.0983 8.5001 10.4314 8.723 10.6468C9.07863 10.8171 9.50689 10.6668 9.6797 10.3112C9.81244 10.0332 9.75233 9.70012 9.52943 9.48474Z",
    fill: "#896024"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.234 8.5C18.1847 8.5 17.2305 9.38658 17.2305 10.8592C17.2305 12.3318 18.1847 13.2159 19.234 13.2159C20.2834 13.2159 21.2376 12.3293 21.2376 10.8592C21.2376 9.38908 20.2834 8.5 19.234 8.5Z",
    fill: "#422B0D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1339 9.48474C18.7783 9.31443 18.35 9.4647 18.1772 9.82033C18.0445 10.0983 18.1046 10.4314 18.3275 10.6468C18.6831 10.8171 19.1114 10.6668 19.2842 10.3112C19.4169 10.0332 19.3568 9.70012 19.1339 9.48474Z",
    fill: "#896024"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3755 21.1905C12.104 21.208 9.93513 20.2538 8.41492 18.5658C8.29972 18.4331 8.27217 18.2452 8.3448 18.0849C8.41743 17.9221 8.57771 17.817 8.75553 17.8145C8.83567 17.8145 8.91582 17.837 8.98594 17.8771C10.1931 18.5708 12.2117 19.4323 14.3755 19.4323H14.4106C16.572 19.4323 18.5931 18.5708 19.7977 17.8771C19.8678 17.837 19.948 17.8145 20.0281 17.8145C20.2059 17.817 20.3662 17.9221 20.4388 18.0849C20.514 18.2452 20.4864 18.4331 20.3687 18.5658C18.8485 20.2538 16.6746 21.2105 14.4031 21.1905",
    fill: "#422B0D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5193 5.67773C27.8542 7.83157 28.5504 10.3961 28.5504 13.2487C28.5504 17.4813 27.0227 21.0627 24.1425 23.6172C21.4878 25.9464 17.8814 27.2487 14.0245 27.2487C9.50145 27.2487 4.758 25.4079 1.95801 21.5034C4.65281 25.9263 9.72184 28 14.5254 28C18.3823 28 21.9887 26.6977 24.6434 24.3685C27.5236 21.814 29.0513 18.2326 29.0513 14.0001C29.0513 10.8094 28.1822 7.97433 26.5193 5.67773Z",
    fill: "#EB8F00"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_3056_1127",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.5259 13.9999) scale(14.2653 14.2653)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FDE030"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#F7C02B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4A223"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmojiSadSmile);
export default __webpack_public_path__ + "static/media/Emoji_SadSmile.3d0972e1cc7fc4e43550a349973858ed.svg";
export { ForwardRef as ReactComponent };